// ConsultationFeedback/MyFeedbacksTab.tsx
import React from 'react';
import {axios} from 'Auth/axiosConfig';
import {IConsultationFeedback} from '../../Types/psychology/consultation';
import ConsultationFeedbackItem from "../ConsultationFeedback/ConsultationFeedbackItem";
import {useErrorProcessing} from "Core/components/ErrorProvider";
import {FC, FRSC} from "WideLayout/Layouts";
import PaginatedList from "Core/components/elements/PaginatedList";
import {useTheme} from "Theme/ThemeContext";
import pprint from '../../Utils/pprint';

interface MyFeedbacksTabProps {
    userId?: number;
    isPsychologist: boolean;
}

const MyFeedbacksTab: React.FC<MyFeedbacksTabProps> = ({userId, isPsychologist}) => {
    const {byResponse} = useErrorProcessing();
    const {plt} = useTheme();

    const loadData = async (page: number): Promise<IConsultationFeedback[]> => {
        try {
            if (!userId) {
                pprint('User ID не найден, возвращаем пустой список отзывов');
                return [];
            }
            const response = await axios.get(`/api/v1/my/feedbacks/`, {
                params: {
                    page,
                    page_size: 20,
                }
            });
            pprint('Loaded feedbacks: ', response.data);
            return response.data.results;
        } catch (e) {
            byResponse(e);
            return [];
        }
    };

    const renderItem = (feedback: IConsultationFeedback, i: number) => (
        <ConsultationFeedbackItem key={i} feedback={feedback}/>
    );

    const renderEmpty = () => (
        <FRSC p={1} color={plt.text.primary60}>
            Нет отзывов.
        </FRSC>
    );

    return (
        <FC maxH={600} scroll={'y-auto'} p={2}>
            <PaginatedList
                loadData={loadData}
                renderItem={renderItem}
                pageSize={20}
                resetTrigger={`${userId}-${isPsychologist}`}
                className="gap-2"
                loadMoreAtTop={false}
                renderEmpty={renderEmpty}
            />
        </FC>
    );
};

export default MyFeedbacksTab;
